// Generated by Melange

import * as CamlinternalLazy from "./camlinternalLazy.js";
import * as Curry from "melange.js/curry.js";

function from_fun(f) {
  return {
    LAZY_DONE: false,
    VAL: (function () {
      return Curry._1(f, undefined);
    })
  };
}

function from_val(v) {
  return {
    LAZY_DONE: true,
    VAL: v
  };
}

function map(f, x) {
  return {
    LAZY_DONE: false,
    VAL: (function () {
      return Curry._1(f, CamlinternalLazy.force(x));
    })
  };
}

function map_val(f, x) {
  if (CamlinternalLazy.is_val(x)) {
    return {
      LAZY_DONE: true,
      VAL: Curry._1(f, CamlinternalLazy.force(x))
    };
  } else {
    return {
      LAZY_DONE: false,
      VAL: (function () {
        return Curry._1(f, CamlinternalLazy.force(x));
      })
    };
  }
}

const Undefined = CamlinternalLazy.Undefined;

const is_val = CamlinternalLazy.is_val;

const force_val = CamlinternalLazy.force_val;

export {
  Undefined,
  map,
  is_val,
  from_val,
  map_val,
  from_fun,
  force_val,
}
/* No side effect */
